import Cookies from 'js-cookie';
import { useCustomEvent } from '@beef/shop-common';

import { COOKIES_NAMES } from 'constants/cookies';

import { /* getCompareCookieName, */ getComparedProductIds } from './selectors';
// import { getStoreCookiePath } from '../settings/selectors';
import { TOGGLE_COMPARE_PRODUCT } from './constants';
import { packCompareProductIds } from './helpers';

/**
 * add remove productId from compare list
 * @param productId - id of product to compare
 */
export const toggleCompareProduct =
  ({ productId }) =>
  (dispatch, getState) => {
    const state = getState();
    // const path = getStoreCookiePath(state);
    const path = '/';
    const compareCookieName = COOKIES_NAMES.COMPARISON_DEVICES;
    let comparedProductIds = getComparedProductIds(state);

    const isCompared = comparedProductIds.indexOf(productId) !== -1;

    /** remove current productId from cookie */
    comparedProductIds = comparedProductIds.filter((id) => id !== productId);
    if (!isCompared) {
      /** and then add it back in */
      comparedProductIds = [...comparedProductIds, productId];
    }

    Cookies.remove(compareCookieName);
    Cookies.set(compareCookieName, packCompareProductIds(comparedProductIds), {
      expires: 365,
      path,
    });

    const { publishDOM } = useCustomEvent();
    publishDOM(COOKIES_NAMES.COMPARISON_DEVICES, comparedProductIds);

    dispatch({
      type: TOGGLE_COMPARE_PRODUCT,
      productId,
      value: !isCompared,
      rnd: Math.random(),
    });
  };
